var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "layout" }, [
    _vm._m(0),
    _vm._v(" "),
    _c("div", { staticClass: "layout__main" }, [
      _c("div", { staticClass: "layout__main-form" }, [
        _c("div", { staticClass: "card" }, [
          _c("div", { staticClass: "card__content" }, [
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-xs-12 col-md-4" }, [
                _c(
                  "div",
                  { staticClass: "form-field" },
                  [
                    _c(
                      "input-field",
                      {
                        attrs: {
                          vMoney: "",
                          format: _vm.porcentaje,
                          id: "porc_interes",
                          placeholder: "Indique el monto..."
                        },
                        model: {
                          value: _vm.form.porc_interes,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "porc_interes", $$v)
                          },
                          expression: "form.porc_interes"
                        }
                      },
                      [
                        _c("span", [_vm._v("% Interés")]),
                        _vm._v(" "),
                        _vm.errores.porc_interes
                          ? _c(
                              "span",
                              {
                                staticClass: "helper-text text-danger",
                                attrs: { slot: "helper" },
                                slot: "helper"
                              },
                              [
                                _c("strong", [
                                  _vm._v(_vm._s(_vm.errores.porc_interes[0]))
                                ])
                              ]
                            )
                          : _vm._e()
                      ]
                    )
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-xs-12 col-md-4" }, [
                _c(
                  "div",
                  { staticClass: "form-field" },
                  [
                    _c(
                      "input-field",
                      {
                        attrs: {
                          id: "monto_maximo_venta",
                          vMoney: "",
                          format: _vm.money,
                          placeholder: "Indique el monto..."
                        },
                        model: {
                          value: _vm.form.monto_maximo_venta,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "monto_maximo_venta", $$v)
                          },
                          expression: "form.monto_maximo_venta"
                        }
                      },
                      [
                        _c("span", [_vm._v("Monto máximo de venta")]),
                        _vm._v(" "),
                        _vm.errores.monto_maximo_venta
                          ? _c(
                              "span",
                              {
                                staticClass: "helper-text text-danger",
                                attrs: { slot: "helper" },
                                slot: "helper"
                              },
                              [
                                _c("strong", [
                                  _vm._v(
                                    _vm._s(_vm.errores.monto_maximo_venta[0])
                                  )
                                ])
                              ]
                            )
                          : _vm._e()
                      ]
                    )
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-xs-12 col-md-4" }, [
                _c(
                  "div",
                  { staticClass: "form-field" },
                  [
                    _c(
                      "input-field",
                      {
                        attrs: {
                          id: "cantidad_ventas",
                          vMoney: "",
                          format: _vm.int,
                          placeholder: "Indique el monto..."
                        },
                        model: {
                          value: _vm.form.cantidad_ventas,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "cantidad_ventas", $$v)
                          },
                          expression: "form.cantidad_ventas"
                        }
                      },
                      [
                        _c("span", [_vm._v("Cantidad de ventas límite")]),
                        _vm._v(" "),
                        _vm.errores.cantidad_ventas
                          ? _c(
                              "span",
                              {
                                staticClass: "helper-text text-danger",
                                attrs: { slot: "helper" },
                                slot: "helper"
                              },
                              [
                                _c("strong", [
                                  _vm._v(_vm._s(_vm.errores.cantidad_ventas[0]))
                                ])
                              ]
                            )
                          : _vm._e()
                      ]
                    )
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-xs-12 col-md-4" }, [
                _c("div", { staticClass: "form-field" }, [
                  _c("label", { attrs: { for: "habilitar_rubro_otros" } }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.form.habilitar_rubro_otros,
                          expression: "form.habilitar_rubro_otros"
                        }
                      ],
                      attrs: {
                        type: "checkbox",
                        name: "habilitar_rubro_otros",
                        id: "habilitar_rubro_otros"
                      },
                      domProps: {
                        checked: Array.isArray(_vm.form.habilitar_rubro_otros)
                          ? _vm._i(_vm.form.habilitar_rubro_otros, null) > -1
                          : _vm.form.habilitar_rubro_otros
                      },
                      on: {
                        change: function($event) {
                          var $$a = _vm.form.habilitar_rubro_otros,
                            $$el = $event.target,
                            $$c = $$el.checked ? true : false
                          if (Array.isArray($$a)) {
                            var $$v = null,
                              $$i = _vm._i($$a, $$v)
                            if ($$el.checked) {
                              $$i < 0 &&
                                _vm.$set(
                                  _vm.form,
                                  "habilitar_rubro_otros",
                                  $$a.concat([$$v])
                                )
                            } else {
                              $$i > -1 &&
                                _vm.$set(
                                  _vm.form,
                                  "habilitar_rubro_otros",
                                  $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                                )
                            }
                          } else {
                            _vm.$set(_vm.form, "habilitar_rubro_otros", $$c)
                          }
                        }
                      }
                    }),
                    _c("span", [
                      _vm._v('Habilitar rubro "Otros" en recaudaciones')
                    ])
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-xs-12 col-md-4" }, [
                _c("div", { staticClass: "form-field" }, [
                  _c("label", { attrs: { for: "producto_manual_ventas" } }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.form.producto_manual_ventas,
                          expression: "form.producto_manual_ventas"
                        }
                      ],
                      attrs: {
                        type: "checkbox",
                        name: "producto_manual_ventas",
                        id: "producto_manual_ventas"
                      },
                      domProps: {
                        checked: Array.isArray(_vm.form.producto_manual_ventas)
                          ? _vm._i(_vm.form.producto_manual_ventas, null) > -1
                          : _vm.form.producto_manual_ventas
                      },
                      on: {
                        change: function($event) {
                          var $$a = _vm.form.producto_manual_ventas,
                            $$el = $event.target,
                            $$c = $$el.checked ? true : false
                          if (Array.isArray($$a)) {
                            var $$v = null,
                              $$i = _vm._i($$a, $$v)
                            if ($$el.checked) {
                              $$i < 0 &&
                                _vm.$set(
                                  _vm.form,
                                  "producto_manual_ventas",
                                  $$a.concat([$$v])
                                )
                            } else {
                              $$i > -1 &&
                                _vm.$set(
                                  _vm.form,
                                  "producto_manual_ventas",
                                  $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                                )
                            }
                          } else {
                            _vm.$set(_vm.form, "producto_manual_ventas", $$c)
                          }
                        }
                      }
                    }),
                    _c("span", [_vm._v("Productos manuales en ventas")])
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-xs-12 col-md-4" }, [
                _c("div", { staticClass: "form-field" }, [
                  _c(
                    "label",
                    { attrs: { for: "producto_manual_recaudacion" } },
                    [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.form.producto_manual_recaudacion,
                            expression: "form.producto_manual_recaudacion"
                          }
                        ],
                        attrs: {
                          type: "checkbox",
                          name: "producto_manual_recaudacion",
                          id: "producto_manual_recaudacion"
                        },
                        domProps: {
                          checked: Array.isArray(
                            _vm.form.producto_manual_recaudacion
                          )
                            ? _vm._i(
                                _vm.form.producto_manual_recaudacion,
                                null
                              ) > -1
                            : _vm.form.producto_manual_recaudacion
                        },
                        on: {
                          change: function($event) {
                            var $$a = _vm.form.producto_manual_recaudacion,
                              $$el = $event.target,
                              $$c = $$el.checked ? true : false
                            if (Array.isArray($$a)) {
                              var $$v = null,
                                $$i = _vm._i($$a, $$v)
                              if ($$el.checked) {
                                $$i < 0 &&
                                  _vm.$set(
                                    _vm.form,
                                    "producto_manual_recaudacion",
                                    $$a.concat([$$v])
                                  )
                              } else {
                                $$i > -1 &&
                                  _vm.$set(
                                    _vm.form,
                                    "producto_manual_recaudacion",
                                    $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                                  )
                              }
                            } else {
                              _vm.$set(
                                _vm.form,
                                "producto_manual_recaudacion",
                                $$c
                              )
                            }
                          }
                        }
                      }),
                      _c("span", [_vm._v("Productos manuales en recaudación")])
                    ]
                  )
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-xs-12 col-md-4" }, [
                _c(
                  "div",
                  { staticClass: "form-field" },
                  [
                    _c(
                      "input-field",
                      {
                        attrs: {
                          id: "dias_cartera",
                          placeholder: "Indique los días separados por coma..."
                        },
                        model: {
                          value: _vm.form.dias_cartera,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "dias_cartera", $$v)
                          },
                          expression: "form.dias_cartera"
                        }
                      },
                      [
                        _c("span", [_vm._v("Días de proyección de cartera")]),
                        _vm._v(" "),
                        _vm.errores.dias_cartera
                          ? _c(
                              "span",
                              {
                                staticClass: "helper-text text-danger",
                                attrs: { slot: "helper" },
                                slot: "helper"
                              },
                              [
                                _c("strong", [
                                  _vm._v(_vm._s(_vm.errores.dias_cartera[0]))
                                ])
                              ]
                            )
                          : _vm._e()
                      ]
                    )
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-xs-12 col-md-4" }, [
                _c(
                  "div",
                  { staticClass: "form-field" },
                  [
                    _c(
                      "input-field",
                      {
                        attrs: {
                          id: "porc_tarjetas",
                          placeholder:
                            "Indique los porcentajes separados por coma..."
                        },
                        model: {
                          value: _vm.form.porc_tarjetas,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "porc_tarjetas", $$v)
                          },
                          expression: "form.porc_tarjetas"
                        }
                      },
                      [
                        _c("span", [_vm._v("% Recaudación en Tarjetas")]),
                        _vm._v(" "),
                        _vm.errores.porc_tarjetas
                          ? _c(
                              "span",
                              {
                                staticClass: "helper-text text-danger",
                                attrs: { slot: "helper" },
                                slot: "helper"
                              },
                              [
                                _c("strong", [
                                  _vm._v(_vm._s(_vm.errores.porc_tarjetas[0]))
                                ])
                              ]
                            )
                          : _vm._e()
                      ]
                    )
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-xs-12 col-md-4" }, [
                _c(
                  "div",
                  { staticClass: "form-field" },
                  [
                    _c(
                      "input-field",
                      {
                        attrs: {
                          id: "porc_tarjeta_recaudador",
                          placeholder:
                            "Indique los porcentajes separados por coma..."
                        },
                        model: {
                          value: _vm.form.porc_tarjeta_recaudador,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "porc_tarjeta_recaudador", $$v)
                          },
                          expression: "form.porc_tarjeta_recaudador"
                        }
                      },
                      [
                        _c("span", [_vm._v("% Recaudación por Recaudador")]),
                        _vm._v(" "),
                        _vm.errores.porc_tarjeta_recaudador
                          ? _c(
                              "span",
                              {
                                staticClass: "helper-text text-danger",
                                attrs: { slot: "helper" },
                                slot: "helper"
                              },
                              [
                                _c("strong", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.errores.porc_tarjeta_recaudador[0]
                                    )
                                  )
                                ])
                              ]
                            )
                          : _vm._e()
                      ]
                    )
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-xs-12 col-md-4" }, [
                _c(
                  "div",
                  { staticClass: "form-field" },
                  [
                    _c(
                      "input-field",
                      {
                        attrs: {
                          id: "porc_supervision",
                          vMoney: "",
                          format: _vm.porcentaje,
                          placeholder:
                            "Indique los porcentajes separados por coma..."
                        },
                        model: {
                          value: _vm.form.porc_supervision,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "porc_supervision", $$v)
                          },
                          expression: "form.porc_supervision"
                        }
                      },
                      [
                        _c("span", [_vm._v("% Supervisión en Recaudación")]),
                        _vm._v(" "),
                        _vm.errores.porc_supervision
                          ? _c(
                              "span",
                              {
                                staticClass: "helper-text text-danger",
                                attrs: { slot: "helper" },
                                slot: "helper"
                              },
                              [
                                _c("strong", [
                                  _vm._v(
                                    _vm._s(_vm.errores.porc_supervision[0])
                                  )
                                ])
                              ]
                            )
                          : _vm._e()
                      ]
                    )
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-xs-12 col-md-4" }, [
                _c(
                  "div",
                  { staticClass: "form-field" },
                  [
                    _c(
                      "input-field",
                      {
                        attrs: {
                          id: "porc_cobradas",
                          vMoney: "",
                          format: _vm.int
                        },
                        model: {
                          value: _vm.form.porc_cobradas,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "porc_cobradas", $$v)
                          },
                          expression: "form.porc_cobradas"
                        }
                      },
                      [
                        _c("span", [
                          _vm._v("Min. Tarj. Cobradas en Rol de Recaudación")
                        ]),
                        _vm._v(" "),
                        _vm.errores.porc_cobradas
                          ? _c(
                              "span",
                              {
                                staticClass: "helper-text text-danger",
                                attrs: { slot: "helper" },
                                slot: "helper"
                              },
                              [
                                _c("strong", [
                                  _vm._v(_vm._s(_vm.errores.porc_cobradas[0]))
                                ])
                              ]
                            )
                          : _vm._e()
                      ]
                    )
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-xs-12 col-md-4" }, [
                _c(
                  "div",
                  { staticClass: "form-field" },
                  [
                    _c(
                      "input-field",
                      {
                        attrs: {
                          id: "porc_incobrable",
                          vMoney: "",
                          format: _vm.porcentaje,
                          placeholder:
                            "Indique los porcentajes separados por coma..."
                        },
                        model: {
                          value: _vm.form.porc_incobrable,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "porc_incobrable", $$v)
                          },
                          expression: "form.porc_incobrable"
                        }
                      },
                      [
                        _c("span", [_vm._v("% Incobrables")]),
                        _vm._v(" "),
                        _vm.errores.porc_incobrable
                          ? _c(
                              "span",
                              {
                                staticClass: "helper-text text-danger",
                                attrs: { slot: "helper" },
                                slot: "helper"
                              },
                              [
                                _c("strong", [
                                  _vm._v(_vm._s(_vm.errores.porc_incobrable[0]))
                                ])
                              ]
                            )
                          : _vm._e()
                      ]
                    )
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-xs-12 col-md-4" }, [
                _c(
                  "div",
                  { staticClass: "form-field" },
                  [
                    _c(
                      "input-field",
                      {
                        attrs: {
                          id: "valor_minimo_cobro",
                          vMoney: "",
                          format: _vm.money,
                          placeholder:
                            "Indique los porcentajes separados por coma..."
                        },
                        model: {
                          value: _vm.form.valor_minimo_cobro,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "valor_minimo_cobro", $$v)
                          },
                          expression: "form.valor_minimo_cobro"
                        }
                      },
                      [
                        _c("span", [_vm._v("Valor mínimo de cobro")]),
                        _vm._v(" "),
                        _vm.errores.valor_minimo_cobro
                          ? _c(
                              "span",
                              {
                                staticClass: "helper-text text-danger",
                                attrs: { slot: "helper" },
                                slot: "helper"
                              },
                              [
                                _c("strong", [
                                  _vm._v(
                                    _vm._s(_vm.errores.valor_minimo_cobro[0])
                                  )
                                ])
                              ]
                            )
                          : _vm._e()
                      ]
                    )
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-xs-12 col-md-4" }, [
                _c(
                  "div",
                  { staticClass: "form-field" },
                  [
                    _c(
                      "input-field",
                      {
                        attrs: {
                          id: "valor_referido",
                          vMoney: "",
                          format: _vm.money,
                          placeholder:
                            "Escriba el valor por tarjeta referida..."
                        },
                        model: {
                          value: _vm.form.valor_referido,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "valor_referido", $$v)
                          },
                          expression: "form.valor_referido"
                        }
                      },
                      [
                        _c("span", [_vm._v("Valor referido")]),
                        _vm._v(" "),
                        _vm.errores.valor_referido
                          ? _c(
                              "span",
                              {
                                staticClass: "helper-text text-danger",
                                attrs: { slot: "helper" },
                                slot: "helper"
                              },
                              [
                                _c("strong", [
                                  _vm._v(_vm._s(_vm.errores.valor_referido[0]))
                                ])
                              ]
                            )
                          : _vm._e()
                      ]
                    )
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-xs-12 col-md-4" }, [
                _c("div", { staticClass: "form-field select2" }, [
                  _c(
                    "div",
                    { staticClass: "select2-field" },
                    [
                      _c("v-select", {
                        attrs: {
                          label: "descripcion",
                          placeholder: "Seleccione...",
                          id: "mov_liq_venta_id",
                          options: _vm.tiposMovimiento
                        },
                        on: { input: _vm.inputTipoMovimiento },
                        model: {
                          value: _vm.selectedTipoMovimiento,
                          callback: function($$v) {
                            _vm.selectedTipoMovimiento = $$v
                          },
                          expression: "selectedTipoMovimiento"
                        }
                      }),
                      _vm._v(" "),
                      _c("label", { attrs: { for: "mov_liq_venta_id" } }, [
                        _vm._v("Tipo de Movimiento Pago Liq. Venta")
                      ])
                    ],
                    1
                  )
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-xs-12 col-md-4" }, [
                _c("div", { staticClass: "form-field select2" }, [
                  _c(
                    "div",
                    { staticClass: "select2-field" },
                    [
                      _c("v-select", {
                        attrs: {
                          label: "descripcion",
                          placeholder: "Seleccione...",
                          id: "mov_tarj_ref_id",
                          options: _vm.tiposMovimiento
                        },
                        on: { input: _vm.inputMovTarjRef },
                        model: {
                          value: _vm.selectedMovTarjRef,
                          callback: function($$v) {
                            _vm.selectedMovTarjRef = $$v
                          },
                          expression: "selectedMovTarjRef"
                        }
                      }),
                      _vm._v(" "),
                      _c("label", { attrs: { for: "mov_tarj_ref_id" } }, [
                        _vm._v("Tipo de Movimiento Tarj. Ref.")
                      ])
                    ],
                    1
                  )
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-xs-12 col-md-4" }, [
                _c("div", { staticClass: "form-field select2" }, [
                  _c(
                    "div",
                    { staticClass: "select2-field" },
                    [
                      _c("v-select", {
                        attrs: {
                          label: "descripcion",
                          placeholder: "Seleccione...",
                          id: "mov_rol_rec_id",
                          options: _vm.tiposMovimientoRecaudacion
                        },
                        on: { input: _vm.inputMovRec },
                        model: {
                          value: _vm.selectedMovRec,
                          callback: function($$v) {
                            _vm.selectedMovRec = $$v
                          },
                          expression: "selectedMovRec"
                        }
                      }),
                      _vm._v(" "),
                      _c("label", { attrs: { for: "mov_rol_rec_id" } }, [
                        _vm._v("Tipo de Movimiento Rol de Recaudador")
                      ])
                    ],
                    1
                  )
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-xs-12 col-md-4" }, [
                _c(
                  "div",
                  { staticClass: "form-field" },
                  [
                    _c(
                      "input-field",
                      {
                        attrs: {
                          type: "password",
                          id: "clave_excel",
                          placeholder: "*******"
                        },
                        model: {
                          value: _vm.form.clave_excel,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "clave_excel", $$v)
                          },
                          expression: "form.clave_excel"
                        }
                      },
                      [
                        _vm._v(
                          "\n                  Clave de archivo de Excel\n                "
                        )
                      ]
                    )
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-xs-12 col-md-4" }, [
                _c(
                  "div",
                  { staticClass: "form-field" },
                  [
                    _c(
                      "input-field",
                      {
                        attrs: {
                          vMoney: "",
                          format: _vm.porcentaje,
                          id: "porc_multa",
                          placeholder: "Indique el porcentaje multa..."
                        },
                        model: {
                          value: _vm.form.porc_multa,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "porc_multa", $$v)
                          },
                          expression: "form.porc_multa"
                        }
                      },
                      [
                        _c("span", [_vm._v("% multa")]),
                        _vm._v(" "),
                        _vm.errores.porc_multa
                          ? _c(
                              "span",
                              {
                                staticClass: "helper-text text-danger",
                                attrs: { slot: "helper" },
                                slot: "helper"
                              },
                              [
                                _c("strong", [
                                  _vm._v(_vm._s(_vm.errores.porc_multa[0]))
                                ])
                              ]
                            )
                          : _vm._e()
                      ]
                    )
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-xs-12 col-md-4" }, [
                _c(
                  "div",
                  { staticClass: "form-field" },
                  [
                    _c(
                      "input-field",
                      {
                        attrs: {
                          id: "cuotas",
                          vMoney: "",
                          format: _vm.int,
                          placeholder: "Indique las cuotas..."
                        },
                        model: {
                          value: _vm.form.cuotas,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "cuotas", $$v)
                          },
                          expression: "form.cuotas"
                        }
                      },
                      [
                        _c("span", [_vm._v("Cuotas")]),
                        _vm._v(" "),
                        _vm.errores.cuotas
                          ? _c(
                              "span",
                              {
                                staticClass: "helper-text text-danger",
                                attrs: { slot: "helper" },
                                slot: "helper"
                              },
                              [
                                _c("strong", [
                                  _vm._v(_vm._s(_vm.errores.cuotas[0]))
                                ])
                              ]
                            )
                          : _vm._e()
                      ]
                    )
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-xs-12 col-md-4" }, [
                _c(
                  "div",
                  { staticClass: "form-field" },
                  [
                    _c(
                      "input-field",
                      {
                        attrs: {
                          vMoney: "",
                          format: _vm.porcentaje,
                          id: "porc_microseguro",
                          placeholder: "Indique el porcentaje multa..."
                        },
                        model: {
                          value: _vm.form.porc_microseguro,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "porc_microseguro", $$v)
                          },
                          expression: "form.porc_microseguro"
                        }
                      },
                      [
                        _c("span", [_vm._v("Microseguro")]),
                        _vm._v(" "),
                        _vm.errores.porc_microseguro
                          ? _c(
                              "span",
                              {
                                staticClass: "helper-text text-danger",
                                attrs: { slot: "helper" },
                                slot: "helper"
                              },
                              [
                                _c("strong", [
                                  _vm._v(
                                    _vm._s(_vm.errores.porc_microseguro[0])
                                  )
                                ])
                              ]
                            )
                          : _vm._e()
                      ]
                    )
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-xs-12 col-md-4" }, [
                _c(
                  "div",
                  { staticClass: "form-field" },
                  [
                    _c(
                      "input-field",
                      {
                        attrs: {
                          vMoney: "",
                          format: _vm.numero,
                          id: "contacto_telefono"
                        },
                        model: {
                          value: _vm.form.contacto_telefono,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "contacto_telefono", $$v)
                          },
                          expression: "form.contacto_telefono"
                        }
                      },
                      [
                        _c("span", [_vm._v("Telefono")]),
                        _vm._v(" "),
                        _vm.errores.contacto_telefono
                          ? _c(
                              "span",
                              {
                                staticClass: "helper-text text-danger",
                                attrs: { slot: "helper" },
                                slot: "helper"
                              },
                              [
                                _c("strong", [
                                  _vm._v(
                                    _vm._s(_vm.errores.contacto_telefono[0])
                                  )
                                ])
                              ]
                            )
                          : _vm._e()
                      ]
                    )
                  ],
                  1
                )
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-xs-12 col-md-6" }, [
                _c("h3", [_vm._v("Comisiones")]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "table-responsive",
                    staticStyle: { "max-height": "300px" }
                  },
                  [
                    _c("table", [
                      _c("thead", [
                        _c("tr", [
                          _c("th", [_vm._v("Venta inicial")]),
                          _vm._v(" "),
                          _c("th", [_vm._v("Venta final")]),
                          _vm._v(" "),
                          _c("th", [_vm._v("Valor de comisión")]),
                          _vm._v(" "),
                          _c("th", [_vm._v("Valor inicial")]),
                          _vm._v(" "),
                          _c("th", [
                            _c("div", [
                              _c(
                                "button",
                                {
                                  staticClass: "btn-success",
                                  on: { click: _vm.agregarComision }
                                },
                                [_c("i", { staticClass: "fa fa-plus" })]
                              )
                            ])
                          ])
                        ])
                      ]),
                      _vm._v(" "),
                      _c(
                        "tbody",
                        [
                          _vm._l(_vm.form.comisiones, function(
                            comision,
                            index
                          ) {
                            return _c("tr", { key: comision.id }, [
                              _c("td", [
                                _c(
                                  "div",
                                  { staticClass: "form-field" },
                                  [
                                    _c("input-field", {
                                      attrs: {
                                        vMoney: "",
                                        format: _vm.money,
                                        placeholder:
                                          "Valor de venta inicial...",
                                        id: "valor_venta_inicial"
                                      },
                                      model: {
                                        value: comision.valor_venta_inicial,
                                        callback: function($$v) {
                                          _vm.$set(
                                            comision,
                                            "valor_venta_inicial",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "comision.valor_venta_inicial"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ]),
                              _vm._v(" "),
                              _c("td", [
                                _c(
                                  "div",
                                  { staticClass: "form-field" },
                                  [
                                    _c("input-field", {
                                      attrs: {
                                        vMoney: "",
                                        format: _vm.money,
                                        placeholder: "Valor de venta final...",
                                        id: "valor_venta_final"
                                      },
                                      model: {
                                        value: comision.valor_venta_final,
                                        callback: function($$v) {
                                          _vm.$set(
                                            comision,
                                            "valor_venta_final",
                                            $$v
                                          )
                                        },
                                        expression: "comision.valor_venta_final"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ]),
                              _vm._v(" "),
                              _c("td", [
                                _c(
                                  "div",
                                  { staticClass: "form-field" },
                                  [
                                    _c("input-field", {
                                      attrs: {
                                        vMoney: "",
                                        format: _vm.money,
                                        placeholder: "Valor de comisión...",
                                        id: "valor_comision"
                                      },
                                      model: {
                                        value: comision.valor_comision,
                                        callback: function($$v) {
                                          _vm.$set(
                                            comision,
                                            "valor_comision",
                                            $$v
                                          )
                                        },
                                        expression: "comision.valor_comision"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ]),
                              _vm._v(" "),
                              _c("td", [
                                _c(
                                  "div",
                                  { staticClass: "form-field" },
                                  [
                                    _c("input-field", {
                                      attrs: {
                                        vMoney: "",
                                        format: _vm.money,
                                        placeholder: "Valor inicial...",
                                        id: "valor_inicial"
                                      },
                                      model: {
                                        value: comision.valor_inicial,
                                        callback: function($$v) {
                                          _vm.$set(
                                            comision,
                                            "valor_inicial",
                                            $$v
                                          )
                                        },
                                        expression: "comision.valor_inicial"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ]),
                              _vm._v(" "),
                              _c("td", [
                                _c(
                                  "button",
                                  {
                                    staticClass: "btn-danger btn--text",
                                    attrs: { type: "button" },
                                    on: {
                                      click: function($event) {
                                        return _vm.eliminarComision(index)
                                      }
                                    }
                                  },
                                  [_c("i", { staticClass: "fa fa-trash" })]
                                )
                              ])
                            ])
                          }),
                          _vm._v(" "),
                          _c(
                            "tr",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.form.comisiones.length == 0,
                                  expression: "form.comisiones.length == 0"
                                }
                              ]
                            },
                            [_vm._m(1)]
                          )
                        ],
                        2
                      )
                    ])
                  ]
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-xs-12 col-md-6" }, [
                _c(
                  "div",
                  {
                    staticClass: "table-responsive",
                    staticStyle: { "max-height": "300px" }
                  },
                  [
                    _c("table", [
                      _vm._m(2),
                      _vm._v(" "),
                      _c(
                        "tbody",
                        [
                          _vm._l(_vm.usuarios, function(usuario) {
                            return _c("tr", { key: usuario.id }, [
                              _c("td", [
                                _vm._v(
                                  "\n                        " +
                                    _vm._s(usuario.usuario.nombre) +
                                    "\n                      "
                                )
                              ]),
                              _vm._v(" "),
                              _c("td", [
                                _vm._v(
                                  "\n                        " +
                                    _vm._s(usuario.version) +
                                    "\n                      "
                                )
                              ]),
                              _vm._v(" "),
                              _c("td", [
                                _vm._v(
                                  "\n                        " +
                                    _vm._s(usuario.fecha_ultima_actualizacion) +
                                    "\n                      "
                                )
                              ])
                            ])
                          }),
                          _vm._v(" "),
                          _c(
                            "tr",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.usuarios.length === 0,
                                  expression: "usuarios.length === 0"
                                }
                              ]
                            },
                            [_vm._m(3)]
                          )
                        ],
                        2
                      )
                    ])
                  ]
                )
              ])
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "layout__main-buttons" }, [
        _c("div", { staticClass: "card" }, [
          _c("div", { staticClass: "card__content" }, [
            _c(
              "button",
              {
                staticClass: "btn-success",
                attrs: { type: "button" },
                on: { click: _vm.guardar }
              },
              [
                _c("i", { staticClass: "fa fa-save" }),
                _c("span", [_vm._v("Guardar")])
              ]
            )
          ])
        ])
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "layout__header" }, [
      _c("div", { staticClass: "layout__title" }, [
        _c("h3", [_vm._v("Parámetros")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", { attrs: { colspan: "4" } }, [
      _c("strong", [_vm._v("No se ha agregado comisiones.")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("Usuario")]),
        _vm._v(" "),
        _c("th", [_vm._v("Versión")]),
        _vm._v(" "),
        _c("th", [_vm._v("Fecha de última actualización")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", { attrs: { colspan: "3" } }, [
      _c("strong", [
        _vm._v("No se ha encontrado actualizaciones de versiones.")
      ])
    ])
  }
]
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-aa1db310", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-aa1db310","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/forms/general/Parametros.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-aa1db310","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/forms/general/Parametros.vue
// module chunks = 0